import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class ItemMaster {
  create = async (itemMaster: any) => {
    await axios({
      method: "post",
      url: `${API_URL}item-master`,
      data: itemMaster,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  edit = async (itemMaster: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}item-master/${code}`,
      data: itemMaster,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}item-master/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.item;
  };
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}item-master`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.items;
  };
  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}item-master-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.item;
  };
  searchService = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}item-master-service-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.item;
  };
  
  posSearch = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}item-price-search-location/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.stock;
  };
}
export default new ItemMaster();
